// import { sendPrompt } from "@q-food/q-food";

export function useWitService() {
	function fetchRawAnswer(message: string) {
		// return sendPrompt(message)
	}

	return {
		fetchRawAnswer,
	};
}
